module.exports = __webpack_public_path__ + "img/3657aae.png";